export function ok(data) {
    return { state: 'ok', data };
}
export function failed(state, detail, said, status) {
    const base = { state, ...(detail === undefined ? {} : { detail }), ...(status === undefined ? {} : { status }) };
    return (said?.key ? { ...base, key: said.key, ...(said.params ? { params: said.params } : {}) } : base);
}
/** Narrows without forcing every caller to write the same conditional. */
export function isOk(r) {
    return r.state === 'ok';
}
//# sourceMappingURL=result.js.map